import React, { useId } from 'react';

// Excel's mark (an "X" tile in front of a sheet) drawn as a 16px Bootstrap-style glyph, so it sits
// with the bi-* icons while staying recognisably Excel. Two greens from the Excel palette.
export default function ExcelIcon({ size = '1.1em', className, style }) {
  const id = useId().replace(/:/g, '');
  const sheetMask = `xl-sheet-${id}`;
  const tileMask = `xl-tile-${id}`;
  return (
    <svg
      viewBox="0 0 16 16"
      width={size}
      height={size}
      className={className}
      style={{ flexShrink: 0, verticalAlign: '-0.15em', ...style }}
      aria-hidden="true"
      focusable="false"
    >
      <mask id={sheetMask}>
        <rect width="16" height="16" fill="#fff" />
        <rect x="0" y="3" width="10" height="10" fill="#000" />
      </mask>
      <mask id={tileMask}>
        <rect width="16" height="16" fill="#fff" />
        <path d="M3.4 5.8l3.2 4.4M6.6 5.8l-3.2 4.4" stroke="#000" strokeWidth="1.35" strokeLinecap="round" />
      </mask>
      {/* The sheet: outline and rows */}
      <g mask={`url(#${sheetMask})`} fill="none" stroke="#21A366" strokeWidth="1">
        <rect x="5.5" y="1.5" width="9" height="13" rx="1.5" />
        <path d="M10 4.5h4.5M10 8h4.5M10 11.5h4.5" />
      </g>
      {/* The tile with the X knocked out */}
      <rect x="1" y="4" width="8" height="8" rx="1.25" fill="#107C41" mask={`url(#${tileMask})`} />
    </svg>
  );
}
